
import Vue from 'vue';
import ComponentBase from '@/mixins/componentBase';
import RepsolFilterBarComponent from '@/components/repsol-filter-bar/RepsolFilterBarComponent.vue';
import RepsolFilterChipsComponent from '@/components/repsol-filter-chips/RepsolFilterChipsComponent.vue';
import RepsolTableComponent from '@/components/repsol-table/RepsolTableComponent.vue';
import RepsolFormPopupComponent from '@/components/repsol-form-popup/RepsolFormPopupComponent.vue';
import { Chip, FormFields, FilterFields, TableHeaderModel } from '@/models/repsol-template.model';

export default Vue.extend({
  name: 'SuscripcionesPage',
  extends: ComponentBase,
  components: {
    RepsolFilterBarComponent,
    RepsolFilterChipsComponent,
    RepsolTableComponent,
    RepsolFormPopupComponent,
  },
  data() {
    return {
      isOpenFilters: false,
      isOpenForm: false,
      formIsValid: true,
      formOnlyRead: false,
      showDialog: false,
      items: [] as any[],
      pendingSubscriptionState: {} as Record<string, boolean>,
      deleteFilter: '',
      popupHeaderText: '',
      itemEdit: {} as any,
      itemEliminar: {
        id: '',
        mensaje: '',
        notificacionId: '',
      } as any,
      filterChips: [] as Chip[],
      formFields: [] as FormFields[],
      filterFields: [] as FilterFields[],
      tableHeaders: [] as TableHeaderModel[],
      tableLoading: false,
      totalItems: 0,
      tableOptions: {
        page: 1,
        itemsPerPage: 10,
        sortBy: [] as string[],
        sortDesc: [] as boolean[],
      },
    };
  },
  mounted() {
    const vm = this as any;

    vm.formFields = [];
    vm.filterFields = [];
    vm.buildTableHeaders();
    vm.getNotificationsAndSubscriptions();
  },
  watch: {
    '$i18n.locale'(): void {
      const vm = this as any;
      vm.buildTableHeaders();
      vm.getNotificationsAndSubscriptions();
    },
  },
  methods: {
    buildTableHeaders() {
      const vm = this as any;

      vm.tableHeaders = [
        {
          text: vm.$t('common.email').toString(),
          value: '',
          sortable: false,
          as: 'btn',
          width: '10%',
          actions: [
            { icon: 'check_box', name: 'emailSi' },
            { icon: 'check_box_outline_blank', name: 'emailNo' },
          ],
        },
        // { text: 'Teams', value: '', sortable: false, as: 'btn', width: '10%', actions: [
        //   { icon: 'check_box', name: 'teamsSi' },
        //   { icon: 'check_box_outline_blank', name: 'teamsNo' },
        // ] },
        {
          text: vm.$t('suscripciones.notification').toString(),
          value: 'notificacionId',
          sortable: false,
          as: 'text',
          items: vm.maestroNotificaciones,
        },
      ];
    },
    async getNotificationsAndSubscriptions() {
      const vm = this as any;
      vm.maestroNotificaciones.splice(0);
      await vm.getMaestroNotificaciones();
      await vm.getSuscripcionesList();
    },
    onTableOptionsChanged(options: any) {
      const vm = this as any;
      vm.tableOptions = { ...options };
      vm.getSuscripcionesList();
    },
    async getSuscripcionesList() {
      const vm = this as any;

      try {
        vm.openSpinner('suscripciones.cargarSuscripciones');
        vm.items = [];

        const filtro: any = {};
        vm.filterFields.forEach((f: any) => {
          if (f.model) {
            filtro[f.name] = f.model;
          }
        });

        const page = vm.tableOptions?.page ?? 1;
        const itemsPerPage = vm.tableOptions?.itemsPerPage ?? 10;
        const sortBy = vm.tableOptions?.sortBy ?? [];
        const sortDesc = vm.tableOptions?.sortDesc ?? [];
        filtro.PageNumber = page || 1;
        filtro.PageSize = itemsPerPage || 10;

        if (sortBy && sortBy.length) {
          filtro.sortBy = sortBy[0];
          filtro.sortDesc = !!(sortDesc && sortDesc[0]);
        }

        const data = await vm.post({ apiUrl: '/api/suscripcion/list', entity: filtro });
        const suscripcionesApi = Array.isArray(data?.items)
          ? data.items
          : (Array.isArray(data) ? data : []);

        const itemsMapeados: any[] = [];

        vm.maestroNotificaciones.forEach((n: any) => {
          const suscripciones = suscripcionesApi.filter((s: any) => s.notificacionId == n.id);

          const emailSuscripcion = suscripciones.find((e: any) => e.mensaje == 'Email');
          const teamsSuscripcion = suscripciones.find((e: any) => e.mensaje == 'Teams');

          itemsMapeados.push({
            id: n.id,
            Id: vm.getSuscripcionId(emailSuscripcion),
            emailId: vm.getSuscripcionId(emailSuscripcion),
            teamsId: vm.getSuscripcionId(teamsSuscripcion),
            notificacionId: n.id,
            emailNo: !emailSuscripcion,
            teamsNo: !teamsSuscripcion,
            emailSi: !!emailSuscripcion,
            teamsSi: !!teamsSuscripcion,
          });
        });

        itemsMapeados.forEach((item: any) => {
          const emailKey = vm.subscriptionStateKey(item.notificacionId, 'Email');
          const teamsKey = vm.subscriptionStateKey(item.notificacionId, 'Teams');

          if (vm.pendingSubscriptionState[emailKey] !== undefined) {
            item.emailSi = vm.pendingSubscriptionState[emailKey];
            item.emailNo = !vm.pendingSubscriptionState[emailKey];
            if (!vm.pendingSubscriptionState[emailKey]) {
              item.emailId = '';
            }
          }

          if (vm.pendingSubscriptionState[teamsKey] !== undefined) {
            item.teamsSi = vm.pendingSubscriptionState[teamsKey];
            item.teamsNo = !vm.pendingSubscriptionState[teamsKey];
            if (!vm.pendingSubscriptionState[teamsKey]) {
              item.teamsId = '';
            }
          }
        });

        vm.items = itemsMapeados;
        vm.totalItems = itemsMapeados.length;
      } catch {
        vm.mostrarKO('suscripciones.koSuscripciones');
      } finally {
        vm.closeSpinner();
      }
    },
    tableEventAction(action: string, item: any): void {
      const vm = this as any;
      let newItem: any;

      switch (action) {
        case 'teamsSi':
          if (!item.teamsId) {
            return;
          }
          vm.itemEliminar = {
            id: item.Id ?? item.teamsId,
            mensaje: 'Teams',
            notificacionId: item.notificacionId,
          };
          vm.showDialog = true;
          break;
        case 'emailSi':
          if (!item.Id) {
            return;
          }
          vm.itemEliminar = {
            id: item.Id,
            mensaje: 'Email',
            notificacionId: item.notificacionId,
          };
          vm.showDialog = true;
          break;
        case 'teamsNo':
          vm.openSpinner('suscripciones.cargarSuscripciones');
          newItem = {
            usuarioId: vm.getUsuarioId(),
            mensaje: 'Teams',
            notificacionId: item.notificacionId,
          };
          if (!newItem.usuarioId) {
            vm.closeSpinner();
            vm.mostrarKO('suscripciones.errorCreacion');
            return;
          }
          vm.aplicarEstadoLocal(item.notificacionId, 'Teams', true);
          vm.post({ apiUrl: '/api/suscripcion', entity: newItem })
            .then((data) => {
              vm.isOpenForm = false;
              vm.closeSpinner();
              vm.aplicarIdRespuesta(item.notificacionId, 'Teams', data);
              vm.limpiarEstadoLocal(item.notificacionId, 'Teams');
              vm.mostrarOK('suscripciones.creacionExitosa');
              vm.getSuscripcionesList();
            })
            .catch(() => {
              vm.limpiarEstadoLocal(item.notificacionId, 'Teams');
              vm.mostrarKO('suscripciones.errorCreacion');
              vm.closeSpinner();
              vm.getSuscripcionesList();
            });
          break;
        case 'emailNo':
          vm.openSpinner('suscripciones.cargarSuscripciones');
          newItem = {
            usuarioId: vm.getUsuarioId(),
            mensaje: 'Email',
            notificacionId: item.notificacionId,
          };
          if (!newItem.usuarioId) {
            vm.closeSpinner();
            vm.mostrarKO('suscripciones.errorCreacion');
            return;
          }
          vm.aplicarEstadoLocal(item.notificacionId, 'Email', true);
          vm.post({ apiUrl: '/api/suscripcion', entity: newItem })
            .then((data) => {
              vm.isOpenForm = false;
              vm.closeSpinner();
              vm.aplicarIdRespuesta(item.notificacionId, 'Email', data);
              vm.limpiarEstadoLocal(item.notificacionId, 'Email');
              vm.mostrarOK('suscripciones.creacionExitosa');
              vm.getSuscripcionesList();
            })
            .catch(() => {
              vm.limpiarEstadoLocal(item.notificacionId, 'Email');
              vm.mostrarKO('suscripciones.errorCreacion');
              vm.closeSpinner();
              vm.getSuscripcionesList();
            });
          break;
        default:
          break;
      }
    },
    eliminarSuscripciones() {
      const vm = this as any;

      vm.showDialog = false;
      if (!vm.itemEliminar.id) {
        vm.closeSpinner();
        vm.mostrarKO('suscripciones.errorEliminar');
        return;
      }
      vm.openSpinner('suscripciones.cargarSuscripciones');
      vm.aplicarEstadoLocal(vm.itemEliminar.notificacionId, vm.itemEliminar.mensaje, false);
      vm.delete({ apiUrl: '/api/suscripcion', entity: { id: vm.itemEliminar.id } })
        .then(() => {
          vm.closeSpinner();
          vm.limpiarEstadoLocal(vm.itemEliminar.notificacionId, vm.itemEliminar.mensaje);
          vm.mostrarOK('suscripciones.eliminarExitosa');
          vm.getSuscripcionesList();
        })
        .catch(() => {
          vm.limpiarEstadoLocal(vm.itemEliminar.notificacionId, vm.itemEliminar.mensaje);
          vm.closeSpinner();
          vm.mostrarKO('suscripciones.errorEliminar');
          vm.getSuscripcionesList();
        });
    },
    subscriptionStateKey(notificacionId: string | number, mensaje: string) {
      return `${notificacionId}:${mensaje}`;
    },
    aplicarEstadoLocal(notificacionId: string | number, mensaje: string, estaSuscrito: boolean) {
      const vm = this as any;
      const fila = vm.items.find((item: any) => item.notificacionId == notificacionId);

      if (!fila) {
        vm.pendingSubscriptionState[vm.subscriptionStateKey(notificacionId, mensaje)] = estaSuscrito;
        return;
      }

      if (mensaje === 'Email') {
        fila.emailSi = estaSuscrito;
        fila.emailNo = !estaSuscrito;
        if (!estaSuscrito) {
          fila.Id = '';
          fila.emailId = '';
        }
      }

      if (mensaje === 'Teams') {
        fila.teamsSi = estaSuscrito;
        fila.teamsNo = !estaSuscrito;
        if (!estaSuscrito) {
          fila.Id = '';
          fila.teamsId = '';
        }
      }

      vm.pendingSubscriptionState[vm.subscriptionStateKey(notificacionId, mensaje)] = estaSuscrito;
      vm.items = [...vm.items];
    },
    aplicarIdRespuesta(notificacionId: string | number, mensaje: string, data?: any) {
      const vm = this as any;
      const fila = vm.items.find((item: any) => item.notificacionId == notificacionId);

      if (!fila) {
        return;
      }

      const responseId = vm.getSuscripcionId(data);

      if (mensaje === 'Email' && responseId) {
        fila.Id = responseId;
        fila.emailId = responseId;
      }

      if (mensaje === 'Teams' && responseId) {
        fila.Id = responseId;
        fila.teamsId = responseId;
      }

      vm.items = [...vm.items];
    },
    limpiarEstadoLocal(notificacionId: string | number, mensaje: string) {
      const vm = this as any;
      delete vm.pendingSubscriptionState[vm.subscriptionStateKey(notificacionId, mensaje)];
    },
    getSuscripcionId(suscripcion: any) {
      if (!suscripcion) {
        return '';
      }

      return suscripcion.id ?? suscripcion.Id ?? suscripcion.ID ?? '';
    },
    getUsuarioId() {
      const vm = this as any;
      return Number(vm.userIdentity?.id ?? vm.userIdentity?.Id ?? 0);
    },
    formEventAction(action: string, item: any): void {
      switch (action) {
        case 'disponible':
          break;
        case 'cancelar':
          this.isOpenForm = false;
          break;
        case 'cambio':
          break;
        default:
          break;
      }
    },
  },
});
